// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Project add/edit dialogs. Field look comes from the antd theme (design-system/theme.js). */

.AddEditProject {
  display: inline-block;
}

.premium-form .inventory-section {
  padding: var(--ds-space-4);
  background: var(--ds-surface-muted);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-lg);
}

.premium-form .inventory-section h5 {
  margin-bottom: var(--ds-space-4);
  font-weight: 700;
  color: var(--ds-text);
}
`, "",{"version":3,"sources":["webpack://./src/commons/Projects/Projects.css"],"names":[],"mappings":"AAAA,6FAA6F;;AAE7F;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,qBAAqB;AACvB","sourcesContent":["/* Project add/edit dialogs. Field look comes from the antd theme (design-system/theme.js). */\n\n.AddEditProject {\n  display: inline-block;\n}\n\n.premium-form .inventory-section {\n  padding: var(--ds-space-4);\n  background: var(--ds-surface-muted);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-lg);\n}\n\n.premium-form .inventory-section h5 {\n  margin-bottom: var(--ds-space-4);\n  font-weight: 700;\n  color: var(--ds-text);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
